import { countriesData } from '@nw4/ui';

export const getDisplayValue = (fieldConfig, fieldValue) => {
  const typeName = (fieldConfig.type || '').toLowerCase();

  if (typeName === 'boolean') {
    return fieldValue === true || fieldValue === 'true' || fieldValue === 1 ? 'yes' : 'no';
  }

  if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
    return '';
  }

  if (typeName === 'conversion' && fieldConfig.conversion) {
    const { metrics, options } = fieldConfig.conversion;
    const key = String(fieldValue);
    const parts = (metrics || [])
      .map((metric) => {
        const match = (options[metric] || []).find((item) => String(item.value) === key);
        return match ? `${metric}: ${match.label}` : null;
      })
      .filter(Boolean);
    if (parts.length > 0) {
      return parts.join(' - ');
    }
  }

  if (typeName === 'choice' && Array.isArray(fieldConfig.options)) {
    const match = fieldConfig.options.find(
      (item) => String(item.value).toLowerCase() === String(fieldValue).toLowerCase()
    );
    if (match) {
      return match.label;
    }
  }

  if (typeName === 'multiplechoice' && Array.isArray(fieldConfig.options)) {
    const selectedIds = String(fieldValue || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
    const labels = fieldConfig.options
      .filter((item) => selectedIds.some((id) => id.toLowerCase() === String(item.value).toLowerCase()))
      .map((item) => item.label);
    if (labels.length > 0) {
      return labels.join(', ');
    }
  }

  if (typeName === 'country') {
    const country = countriesData.find((item) => item.code === fieldValue);
    return country ? country.name : fieldValue;
  }

  return typeof fieldValue === 'number' ? String(fieldValue) : fieldValue;
};
